import { COMBO_CAP, COMBO_STEP, EXTRA_LIFE_AT, HIGH_SCORE_KEY, LEVEL_BONUS, LIFE_BONUS, UNLOCKED_KEY } from './constants';
import { LEVELS } from './levels';

export function comboMultiplier(combo: number): number {
  return Math.min(COMBO_CAP, 1 + Math.max(0, combo - 1) * COMBO_STEP);
}

export function brickScore(base: number, combo: number): number {
  return Math.round(base * comboMultiplier(combo));
}

export function levelClearBonus(level: number, lives: number): { levelBonus: number; lifeBonus: number; total: number } {
  const levelBonus = level * LEVEL_BONUS;
  const lifeBonus = lives * LIFE_BONUS;
  return { levelBonus, lifeBonus, total: levelBonus + lifeBonus };
}

export function extraLivesEarned(prevScore: number, nextScore: number, claimed: Set<number> = new Set()): number[] {
  return EXTRA_LIFE_AT.filter((n) => prevScore < n && nextScore >= n && !claimed.has(n));
}

export function loadHighScore(): number {
  try {
    const raw = window.localStorage.getItem(HIGH_SCORE_KEY);
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
  } catch {
    return 0;
  }
}

export function saveHighScore(score: number): number {
  const prev = loadHighScore();
  const next = Math.max(prev, Math.floor(score));
  try {
    window.localStorage.setItem(HIGH_SCORE_KEY, String(next));
  } catch {
    /* private mode */
  }
  return next;
}

export function clampLevelId(id: number, max = LEVELS.length): number {
  if (!Number.isFinite(id)) return 1;
  return Math.max(1, Math.min(max, Math.floor(id)));
}

/** Highest level id the player has cleared. 0 means none yet. */
export function loadUnlocked(max = LEVELS.length): number {
  try {
    const n = Number(window.localStorage.getItem(UNLOCKED_KEY));
    if (!Number.isFinite(n) || n <= 0) return 0;
    return Math.min(max, Math.floor(n));
  } catch {
    return 0;
  }
}

/** Completing `clearedId` records that level as cleared. */
export function unlockAfterClear(clearedId: number, max = LEVELS.length): number {
  const cleared = clampLevelId(clearedId, max);
  const unlocked = Math.max(loadUnlocked(max), cleared);
  try {
    window.localStorage.setItem(UNLOCKED_KEY, String(unlocked));
  } catch {
    /* private mode */
  }
  return unlocked;
}
